import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/omnitecActions'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

export const fetchOmnitecEncoders = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.OMNITEC_ENCODERS_FETCH_REQUEST })
    const { auth } = getState()

    // fetch(urls.omnitecEncodersFetch(organizationId), { method: 'GET' })
    securedFetch(urls.omnitecEncodersFetch(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_fetchEncodersSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_fetchEncodersFailure,
                'Что-то пошло не так!',
                'При получении энкодеров произошла ошибка'
            )
        )
}

export const createOmnitecEncoders = body => (dispatch, getState) => {
    const { auth } = getState()

    const { organizationId } = body

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }

    securedFetch(urls.omnitecEncodersCreate, auth, opts)
        // fetch(urls.omnitecEncodersCreate, opts)
        .then(handleResponse)
        .then(json => {
            securedFetch(urls.omnitecEncodersFetch(organizationId), auth, { method: 'GET' })
                .then(handleResponse)
                .then(json => dispatch(actions.omnitec_fetchEncodersSuccess(json)))
                .catch(
                    handleError(
                        dispatch,
                        actions.omnitec_fetchEncodersFailure,
                        'Что-то пошло не так!',
                        'При получении энкодеров произошла ошибка'
                    )
                )
            return json
        })
        .catch(
            handleError(
                dispatch,
                actions.omnitec_createEncodersFailure,
                'Что-то пошло не так!',
                'При создании энкодера произошла ошибка'
            )
        )
}

export const deleteOmnitecEncoders = id => (dispatch, getState) => {
    dispatch({ type: ActionTypes.OMNITEC_ENCODERS_FETCH_REQUEST })
    const { auth } = getState()

    // fetch(urls.omnitecEncodersFetch(organizationId), { method: 'GET' })
    securedFetch(urls.omnitecEncoderDelete(id), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_deleteEncodersSuccess(id)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_deleteEncodersFailure,
                'Что-то пошло не так!',
                'При получении энкодеров произошла ошибка'
            )
        )
}


// WEBPACK FOOTER //
// ./src/api/omnitecApi/omnitecEncoders.js